// data-scroll >>

$('*[data-scroll]').on('click', function () {
    let target = $(this).attr('data-scroll');
    let headerHeight = 50;

    if ($(window).width() >= 1024) {
        headerHeight = 60;
    }

    scrollWin(target, 1000, headerHeight * -1);

    if (typeof $(this).data('history') !== 'undefined') {
        window.location.hash = target;
    }

    return false;
});

// << data-scroll

// scrollWin >>

function scrollWin(el, time, editPos) {
    let finalPos = $(el).offset().top;

    if (editPos) finalPos += editPos;

    $('body, html').stop().animate({
        scrollTop: finalPos
    }, time);
}

// << scrollWin